export interface PremiumPersonalizedPlanPayload {
    id: number
    user_id: number
    first_name: string | null
    last_name: string | null
    email: string
    country: string | null
    legacy: boolean
    eligible_for_30d_trial: boolean
    plan_activated: boolean
    trial: boolean
    product_id: string | null
    programs_count: number
    program_id: number | null
    program_name: string | null
}

export class PremiumPersonalizedPlan {
    id: number
    userId: number
    firstName: string | null
    lastName: string | null
    email: string
    country: string | null
    legacy: boolean
    eligibleFor30dTrial: boolean
    planActivated: boolean
    trial: boolean
    productId: string | null
    programsCount: number
    programId: number | null
    programName: string | null

    constructor(data: PremiumPersonalizedPlanPayload) {
        this.id = data.id
        this.userId = data.user_id
        this.firstName = data.first_name
        this.lastName = data.last_name
        this.email = data.email
        this.country = data.country
        this.legacy = data.legacy
        this.eligibleFor30dTrial = data.eligible_for_30d_trial
        this.planActivated = data.plan_activated
        this.trial = data.trial
        this.productId = data.product_id
        this.programsCount = data.programs_count
        this.programId = data.program_id
        this.programName = data.program_name
    }
}
